module.exports = __webpack_public_path__ + "assets/img/axel.104da363.jpg";